module.exports = __webpack_public_path__ + "static/media/sub-down.8e32afe1.svg";